import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LearnProgressBarComponent } from './learn-progress-bar.component';

@NgModule({
  imports: [
    CommonModule,
    LearnProgressBarComponent
  ],
  exports: [LearnProgressBarComponent]
})
export class LearnProgressBarModule {
}

export {
  LearnProgressBarComponent
};
